import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=7a1201b6&scoped=true&"
import script from "./Header.vue?vue&type=script&lang=ts&setup=true&"
export * from "./Header.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./Header.vue?vue&type=style&index=0&id=7a1201b6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a1201b6",
  null
  
)

export default component.exports